<mat-toolbar
  color="primary"
  class="apearAnimation flex-row flex content-between relative rounded-md"
>
  <div class="absolute left-0 pl-2">
    <span class="font-semibold">Deportistas Elimiados</span>
  </div>
</mat-toolbar>

<div class="margin-container apearAnimation">
  <div
    class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2"
  >
    <mat-form-field appearance="outline" class="w-full md:w-auto">
      <mat-label>Nombre o Número de documento</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchString"
        (keyup.enter)="onEnter()"
      />
      <button
        mat-icon-button
        *ngIf="searchString"
        matSuffix
        aria-label="Clear"
        (click)="searchString = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

<!--     <mat-form-field
      appearance="outline"
      class="example-full-width"
      style="padding-left: 10px; font-size: smaller"
    >
      <mat-label>Ordenar por</mat-label>
      <mat-select
        [(ngModel)]="ordenamientoSelect"
        (selectionChange)="cambioDiscipinaBuscar()"
      >
        <mat-option value="0"> Alfabético asc</mat-option>
        <mat-option value="1"> Alfabético desc</mat-option>
        <mat-option value="2"> Fecha de creación asc </mat-option>
        <mat-option value="3"> Fecha de creación desc </mat-option>
      </mat-select>
    </mat-form-field> -->

    <button
      style="margin-left: 10px"
      (click)="onEnter()"
      mat-raised-button
      color="primary"
    >
      Buscar
    </button>
  </div>

  <div class="loading-indicator" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table class="table-fixed" [dataSource]="dataSource">
      <ng-container matColumnDef="nombre" sticky>
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element" class="txtMayuscula">
          {{ element.nombre }}
          <mat-icon
            *ngIf="!element.conHorarios"
            matTooltip="Usuario sin horarios"
            matTooltipPosition="after"
            color="warn"
            style="cursor: pointer"
          >
            warning
          </mat-icon>

          <br />
          <small>{{ element.documento }}</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="fechaFin">
        <th mat-header-cell *matHeaderCellDef>
          Fecha límite ingreso <small>dd-mm-aa</small>
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            
          >
            {{ element.fechaIngresoHasta | date : "dd-MM-yy" }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="botones">
        <th mat-header-cell *matHeaderCellDef style="min-width: 200px"></th>
        <td mat-cell *matCellDef="let element">
          <div class="muestraBotones">
            <button
              title="Activar deportista"
              mat-icon-button
              color="warn"
              aria-label="Activar"
              mat-icon-button
              aria-label="Activar"
              (click)="activar(element)"
            >
              <mat-icon>check_circle</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100, 250, 500]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</div>
